<template>
  <div class="bg__highlight soft">
			<h3 class="beta">
				{{ title}}
			</h3>
			<p>{{message}}</p>
	</div>
</template>

<script>
export default {
	name: 'WarningCallout',
	props: {
		title: String,
		message: String
	},
}
</script>